import React, { Component } from 'react'
import styled from 'styled-components'
// import IrregularInteraction from '../../IrregularInteraction'
import ItemImageAnimated from '../../ItemImageAnimated'
import Frame1Image from '../../../assets/images/bedroom/item--cat--f1@3x.png'
import Frame2Image from '../../../assets/images/bedroom/item--cat--f2@3x.png'
import Frame3Image from '../../../assets/images/bedroom/item--cat--f3@3x.png'
import Frame4Image from '../../../assets/images/bedroom/item--cat--f4@3x.png'
import Frame5Image from '../../../assets/images/bedroom/item--cat--f5@3x.png'
import Frame6Image from '../../../assets/images/bedroom/item--cat--f6@3x.png'
import Frame7Image from '../../../assets/images/bedroom/item--cat--f7@3x.png'
import Frame8Image from '../../../assets/images/bedroom/item--cat--f8@3x.png'
import Frame9Image from '../../../assets/images/bedroom/item--cat--f9@3x.png'

const frames = [
  Frame1Image,
  Frame2Image,
  Frame3Image,
  Frame4Image,
  Frame5Image,
  Frame6Image,
  Frame7Image,
  Frame8Image,
  // Frame9Image,
  // Frame8Image,
  Frame7Image,
  Frame6Image,
  Frame5Image,
  Frame4Image,
  Frame3Image,
  Frame2Image,
]

const Chloe = ({ animate, ...props }) => (
  <ItemImageAnimated srcs={frames} fps={2} animate={true} />
)

Chloe.propTypes = ItemImageAnimated.propTypes

export default Chloe



// WEBPACK FOOTER //
// ./src/components/items/bedroom/Chloe.js